// src/utils/logger.js
import config from "../config";

/**
 * Conditional logger that respects the REACT_APP_ENABLE_CONSOLE_LOGGING flag.
 *
 * This utility provides a drop-in replacement for console methods that can be
 * toggled on/off via environment variables. This is useful for:
 * - Enabling verbose logging in development/QA
 * - Disabling logging in production for cleaner browser console
 * - Consistent logging control similar to backend's enableSlackLogging flag
 *
 * Usage:
 *   import logger from './utils/logger';
 *
 *   logger.log('Debug information');
 *   logger.warn('Warning message');
 *   logger.error('Error - always shown');
 *
 * Note: console.error() always passes through regardless of the flag,
 * as errors should always be visible for debugging.
 */

const logger = {
  log: (...args) => {
    if (config.enableConsoleLogging) {
      console.log(...args);
    }
  },

  info: (...args) => {
    if (config.enableConsoleLogging) {
      console.info(...args);
    }
  },

  warn: (...args) => {
    if (config.enableConsoleLogging) {
      console.warn(...args);
    }
  },

  debug: (...args) => {
    if (config.enableConsoleLogging) {
      console.debug(...args);
    }
  },

  // Always allow errors through - they're important for debugging
  error: (...args) => {
    console.error(...args);
  },

  // Utility to check if logging is enabled
  isEnabled: () => config.enableConsoleLogging,
};

export default logger;
